<div>
  <fieldset class="form-group">
    <div [class.disabled]="disabled" class="custom-control custom-checkbox">
      <input class="custom-control-input"
             type="checkbox"
             [ngModel]="model"
             (ngModelChange)="onModelChange($event)"
             (change)="onSelect($event)"
             [name]="name"
             [attr.disabled]="disabled">
      <label class="custom-control-label" [attr.for]="buildChildId()">
        <span>{{label}}</span>
      </label>
    </div>
  </fieldset>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-checkbox/achoo-checkbox.component.html